import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE } from 'modules/authorizations/store/types/temporaryLivingTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { updateTemporaryLivingAssignments } from 'modules/authorizations/store/actions/temporaryLiving.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useMemo, useState } from 'react';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { formatTripAddress } from 'modules/authorizations/utils';

const PropertyCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { tempLivingAssignment, enumerations, authId, disableEdit } = props;
  const tempLivingInfo = tempLivingAssignment.temporaryLivingAssignment;

  const tabs = [{ header: 'Property', order: 1, iconPath: ['fas', 'house'] }];

  const bookingSources =
    enumerations && enumerations.bookingSources && enumerations.bookingSources.length > 0
      ? enumerations.bookingSources.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];

  const provinces =
    enumerations && enumerations.provinces && enumerations.provinces.length > 0
      ? enumerations.provinces.filter(s => s.isActive === true && isIdEqual(s.countryId, 'D94A0819-59A2-443F-BC99-1EE360057F38'))
      : [{ id: ZERO_GUID, title: '' }];

  const countries =
    enumerations && enumerations.countries && enumerations.countries.length > 0
      ? enumerations.countries.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];

  const addr = useMemo(() => tempLivingAssignment?.propertyAddress ?? tempLivingAssignment?.PropertyAddress ?? null, [
    tempLivingAssignment
  ]);

  const summaries = [
    {
      header: 'Confirm Booking Source',
      accessorKey: 'confirmBookingSourceId',
      type: 'dropdown-v2',
      options: bookingSources,
      required: false,
      value: tempLivingInfo ? tempLivingInfo.confirmBookingSourceId ?? ZERO_GUID : ZERO_GUID,
      tab: 1
    },
    {
      header: 'Complex Name',
      accessorKey: 'complexName',
      type: 'text',
      required: false,
      value: tempLivingInfo ? tempLivingInfo.complexName ?? '' : '',
      tab: 1
    },
    // {
    //   header: 'Street Address',
    //   accessorKey: 'addressLine1',
    //   type: 'text',
    //   required: false,
    //   value: addr ? addr.addressLine1 ?? '' : '',
    //   tab: 1
    // },
    // {
    //   header: 'Unit / Address Line 2',
    //   accessorKey: 'addressLine2',
    //   type: 'text',
    //   required: false,
    //   value: addr ? addr.addressLine2 ?? '' : '',
    //   tab: 1
    // },
    // {
    //   header: 'City',
    //   accessorKey: 'city',
    //   type: 'text',
    //   required: false,
    //   value: addr ? addr.city ?? addr.City ?? '' : '',
    //   tab: 1
    // },
    // {
    //   header: 'State/Province',
    //   accessorKey: 'provinceId',
    //   type: 'dropdown-v2',
    //   options: provinces,
    //   required: false,
    //   value: addr ? addr.provinceId ?? ZERO_GUID : ZERO_GUID,
    //   tab: 1
    // },
    // {
    //   header: 'Zip/Postal Code',
    //   accessorKey: 'zipcode',
    //   type: 'text',
    //   required: false,
    //   value: addr ? addr.zipcode ?? '' : '',
    //   tab: 1
    // },
    // {
    //   header: 'Country',
    //   accessorKey: 'countryId',
    //   type: 'dropdown-v2',
    //   options: countries,
    //   required: false,
    //   value: addr ? addr.countryId ?? ZERO_GUID : ZERO_GUID,
    //   tab: 1
    // },
    {
      header: 'Daily Rate',
      accessorKey: 'dailyRate',
      type: 'number',
      required: false,
      value: tempLivingInfo?.dailyRate,
      tab: 1
    },
    {
      header: 'Supplier Contact Name',
      accessorKey: 'propertyContactName',
      type: 'text',
      required: false,
      value: tempLivingInfo?.propertyContactName,
      tab: 1
    },
    {
      header: 'Supplier Phone',
      accessorKey: 'propertyPhone',
      type: 'text',
      required: false,
      value: tempLivingInfo?.propertyPhone,
      tab: 1
    },
    {
      header: 'Supplier Email',
      accessorKey: 'propertyEmail',
      type: 'text',
      required: false,
      value: tempLivingInfo?.propertyEmail,
      tab: 1
    },
    {
      header: 'Address',
      accessorKey: 'editedAddress',
      type: 'googleAddressSearch',
      required: false,
      value: addr ? addr : '',
      displayValue: formatTripAddress(addr, enumerations?.provinces, enumerations?.countries),
      tab: 1,
      countries: countries,
      provinces: provinces
    }
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...tempLivingAssignment };

    newValues.temporaryLivingAssignment.confirmBookingSourceId = values.confirmBookingSourceId ?? ZERO_GUID;
    newValues.temporaryLivingAssignment.complexName = values.complexName ?? '';
    newValues.temporaryLivingAssignment.propertyPhone = values.propertyPhone ?? '';
    newValues.temporaryLivingAssignment.propertyEmail = values.propertyEmail ?? '';

    const current = newValues.propertyAddress ?? {};
    newValues.propertyAddress = {
      ...current,
      addressId: current.addressId ?? 0,
      addressTypeId: '1F0D8224-AAE0-40A3-A91D-E0344CEDC3F5',
      addressLine1: values.editedAddress.addressLine1 ?? '',
      city: values.editedAddress.city ?? '',
      county: values.editedAddress.county ?? '',
      countryId: values.editedAddress.countryId ?? '00000000-0000-0000-0000-000000000000',
      provinceId: values.editedAddress.provinceId ?? '00000000-0000-0000-0000-000000000000',
      zipcode: values.editedAddress.zipcode ?? '',
      addedBy: current.addedBy ?? current.AddedBy ?? 0,
      addedOn: current.addedOn ?? current.AddedOn ?? new Date().toISOString(),
      modifiedBy: current.modifiedBy ?? current.ModifiedBy ?? 0,
      modifiedOn: new Date().toISOString()
    };

    newValues.temporaryLivingAssignment.dailyRate = values.dailyRate === '' ? null : values.dailyRate;
    newValues.temporaryLivingAssignment.propertyContactName = values.propertyContactName ?? '';
    newValues.temporaryLivingAssignment.propertyPhone = values.propertyPhone ?? '';
    newValues.temporaryLivingAssignment.propertyEmail = values.propertyEmail ?? '';
    
    const tliId = tempLivingAssignment.temporaryLivingAssignmentId;
    if (authId && tliId) {
      const resp = await props.updateTemporaryLivingAssignments(authId, tliId, newValues);
      if (resp.type === UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
        props.showToast('Failed to update the assignment info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    } else {
      setIsLoading(false);
      return false;
    }
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={4}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={disableEdit}
    />
  );
};

export default compose(
  connect(null, {
    updateTemporaryLivingAssignments,
    showToast
  })
)(PropertyCard);
